import { NgModule } from '@angular/core'
import { provideConfig, RoutingConfig } from '@spartacus/core'
import { CmsInjectorService } from '@spartacus/storefront'
import { MbCmsInjectorService } from './services/cms-injector/cms-injector.service'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        universityFeatureModule: {
          module: () => import('./university.module').then((m) => m.UniversityModule),
          cmsComponents: ['training_usp', 'trainingteaserslider', 'training_objectives', 'training_locations', 'training_list',
            'training_header', 'training_facet', 'training_description', 'training_categories'],
        },
      }
    }),
    {
      provide: CmsInjectorService,
      useExisting: MbCmsInjectorService
    },
    provideConfig({
      routing: {
        routes: {
          university: {
            paths: ['resources/miltenyi-university']
          },
          universityPage: {
            paths: ['resources/miltenyi-university/:id'],
            paramsMapping: { id: 'id' },
          },
          universityHomepage: {
            paths: ['resources/miltenyi-university.html']
          }
        }
      }
    } as RoutingConfig)
  ]
})
export class UniversityFeatureModule {
}
